export default __webpack_public_path__ + "c37e454497277db8745e718cd389f469.svg";